import RowActionsCell from '@organisms/DataGrid/parts/RowActionsCell';
import GroupActionButton from '@molecules/GroupActionButton/GroupActionButton';
import { IActionService } from '@services/actions/IActionService';
import { IBaseAction } from '@models/actions/IBaseAction';
import { IDataGridService } from '@services/IDataGridService';
import DataGrid from '@organisms/DataGrid/DataGrid';
import { useDataGridActions } from '@organisms/DataGrid/useDataGridActions';
import { useContext } from 'react';
import { DocumentTitleContext } from '@/context/DocumentContext';
import { ITableSchemeDebug } from '@molecules/DebugPanel/TableSchemeDebug/tableSchemeDebug';

export interface IDocumentLinksGridProps {
    dataKey: string;
    /** Имя таблицы связей — заголовок полноэкранного режима. */
    title?: string;
    service: IDataGridService;
    actionService?: IActionService<IBaseAction>;
    linkPrefix?: string;
    readOnly?: boolean;
    /** Жучок схемы: виден только тем, кто видит панель отладки. */
    schemeDebug?: ITableSchemeDebug;
}

/**
 * Связанные документы на базовом гриде.
 * Действия строки и групповые остаются прежними — меняется только таблица.
 */
const DocumentLinksGrid = ({
    dataKey,
    title,
    service,
    actionService,
    linkPrefix,
    readOnly,
    schemeDebug,
}: IDocumentLinksGridProps) => {
    const { openRowLink, refreshToken, refresh, groupActionsRef, onSelectionChange } = useDataGridActions();
    const documentTitle = useContext(DocumentTitleContext);

    return (
        <DataGrid
            dataKey={dataKey}
            service={service}
            linkPrefix={linkPrefix}
            onOpenRowLink={linkPrefix ? openRowLink : undefined}
            readOnly={readOnly}
            refreshToken={refreshToken}
            onSelectionChange={onSelectionChange}
            allowFullscreen
            stickyHeader
            fullscreenTitle={title || 'Связанные документы'}
            fullscreenContext={documentTitle}
            schemeDebug={schemeDebug}
            toolbarStart={
                actionService ? (
                    <GroupActionButton controlRef={groupActionsRef} service={actionService} onModifyData={refresh} />
                ) : undefined
            }
            rowActions={
                actionService
                    ? (row) => <RowActionsCell row={row} service={actionService} onModifyData={refresh} />
                    : undefined
            }
        />
    );
};

export default DocumentLinksGrid;
